var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgXIcon = function SvgXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 4.894 4.593-4.65a.818.818 0 0 1 1.166 0 .843.843 0 0 1 0 1.18L7.239 6l4.52 4.575a.844.844 0 0 1 0 1.18.818.818 0 0 1-1.166 0L6 7.107l-4.593 4.65a.818.818 0 0 1-1.166 0 .843.843 0 0 1 0-1.18L4.761 6 .24 1.425a.844.844 0 0 1 0-1.18.818.818 0 0 1 1.166 0L6 4.893z",
    fillRule: "evenodd"
  })));
};

export default SvgXIcon;